import { render, staticRenderFns } from "./ProductsListSideBarFilter.vue?vue&type=template&id=39cc8a3e&"
import script from "./ProductsListSideBarFilter.vue?vue&type=script&lang=js&"
export * from "./ProductsListSideBarFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports